import $ from 'jquery/dist/jquery.min'
import 'nouislider/distribute/nouislider.min.css'
import noUiSlider from 'nouislider/distribute/nouislider.min.js'
import PropertyTemplate from './PropertyTemplate.jsx';
import PropertiesSortingService from './PropertiesSortingService.jsx';
import PropertiesGoogleMap from './PropertiesGoogleMap.jsx';
import PropertiesMobileTabs from './PropertiesMobileTabs.jsx';

export default class PropertiesApp {

  constructor() {
    this.$propertiesContainer = $('#properties-container');
    this.$loadingDiv = $('<div></div>').attr({id: 'loading'}).text('loading...');
    this.allProperties;
    // this.$filterSpaceType = $('.properties-filter-spacetype');
    this.$resetFiltersButton = $('.js-filter-reset');
    this.$filterSelects = $('.properties-filter--input');
    this.filterRangeSlider;
    // this.$filterShortTerm = $('.properties-filter-shortterm');
    this.$showAvailableSpaceOnly = $('.properties-available-space-only');
    this.$footageIndicator = $('.footage-indicator');
    this.$sortButtons = $('.sorter');
    this.googleMap;
    this.filterParams = {};
    this.sortParams = {};
    this.squareFootageRange;
    this.visibleProperties = [];
    this.mobileTabs = new PropertiesMobileTabs();
    this.sortingService = new PropertiesSortingService();
    this.maximumSquareFootageForGraph = 25000;
    this.$seeAllResultsButton = $('#see-results');
  }

  initGoogleMap() {
    this.googleMap = new PropertiesGoogleMap();
    return this.googleMap.initGoogleMap(); //promise object
  }

  initPropertiesApp() {
    this.getAllProperties();
  }

  getAllProperties() {
    this.addLoading();
    this.initSortParams();
    this.initMobileTabs();
    $.getJSON('/api/v1/properties-slim.json', function( data, textStatus) {
      this.allProperties = data.properties;
      this.initialTasks();
      this.initFilterParams();
      this.renderFootageIndicator();
      this.renderTemplates();
      this.listenForFilterChange();
      this.listenForMinRangeChange();
      this.listenForSortChange();
      this.initGoogleMap().then(function(response){
        if (response) {
          this.populateMap();
        }
        else {
          console.log('oops');
        }
      }.bind(this));
    }.bind(this));
  }

  // TODO: change this to overlay for sorting/filtering/map
  addLoading() {
    // $('.page-content').prepend(this.$loadingDiv)
  }
  removeLoading() {
    this.$loadingDiv.remove();
  }

  initialTasks() {
    this.setRetailSquareFootageRange();
    this.createSlider();
    this.createSliderGraph();
    this.enableActions();
    this.removeLoading();
  }

  initFilterParams() {
    this.filterParams = {
      spaceType: 'retail',
      footageRange: [0, this.squareFootageRange[1]],
      // shortTerm: false
    }
  }

  initSortParams() {
    this.sortParams = this.sortingService.initSortParams();
  }

  initMobileTabs() {
    this.mobileTabs.initMobileTabs();
    this.mobileTabs.listenForTabChange();
    this.mobileTabs.listenForWindowChange();
  }

  updateSeeAllButton() {
    const numProperties = this.visibleProperties.length
    const buttonText = `${numProperties} ${numProperties == 1 ? 'Result' : 'Results'}`
    this.$seeAllResultsButton.find('span').text(buttonText);
  }

  enableActions() {
    this.$filterSelects.add(this.$resetFiltersButton)
                       // .add(this.$filterSpaceType)
                       // .add(this.$filterShortTerm)
                       .add(this.$showAvailableSpaceOnly)
                       .add(this.$sortButtons)
                       .prop('disabled', false);
    $('#'+this.filterRangeSlider.target.id).removeAttr('disabled')
  }

  renderTemplates() {
    this.clearProperties();
    this.filterProperties();
    this.visibleProperties = this.sortingService.sortProperties(this.visibleProperties, this.sortParams)
    this.updateSeeAllButton();
    let templates = [];
    this.visibleProperties.forEach(function(property){
      const template = new PropertyTemplate(property);
      const renderedTemplate = template.renderTemplate();
      templates.push(renderedTemplate);
    }, this);

    this.$propertiesContainer.append(templates);
  }

  populateMap() {
    this.googleMap.updateMarkers(this.visibleProperties, this.allProperties);
  }

  clearProperties() {
    this.$propertiesContainer.empty();
  }

  setMinRange() {
    const app = this;
    this.$showAvailableSpaceOnly.change(function(e){
      const maxValue = parseInt(app.filterRangeSlider.get()[1]);
      const range = this.checked ?
        [app.squareFootageRange[0], maxValue] :
        [0, maxValue];

      app.filterRangeSlider.set(range);
      app.filterParams.footageRange = range;
      app.renderTemplates();
      app.populateMap(this.visibleProperties);

    });
  }

  listenForFilterChange() {
    this.setFilterParams();
    this.filterRangeSlider.on('update', function(range){
      this.renderFootageIndicator(range);
    }.bind(this));
  }

  listenForMinRangeChange() {
    this.setMinRange();
  }

  listenForSortChange() {
    this.setSortParams();
  }

  renderFootageIndicator(range) {
    const thisRange = range ? range : this.filterParams.footageRange;
    const maxFootageRangeDisplay = thisRange[1] > this.maximumSquareFootageForGraph ? "25k+" : parseInt(thisRange[1]);
    const indicator = `${parseInt(thisRange[0])} - ${maxFootageRangeDisplay}`;
    this.$footageIndicator.html(indicator);
  }

  setFilterParams() {
    const app = this;
    this.$resetFiltersButton.click(function() {
      app.clearAllFilters();
      app.renderTemplates();
      app.populateMap(this.visibleProperties);
    });
    // this.$filterSpaceType.change(function() {
    //   app.filterParams.spaceType = this.value;
    //   app.renderTemplates();
    //   app.populateMap(this.visibleProperties);
    // });
    this.$filterSelects.change(function() {
      app.clearFilterSelects(this);
      const category = $(this).data('filter');
      if (this.value) {
        app.filterParams[category] = this.value;
      }
      else {
        app.clearAllFilters();
      }
      app.renderTemplates();
      app.populateMap(this.visibleProperties);
    });
    this.filterRangeSlider.on('change', function(range){
      app.filterParams.footageRange = range;
      app.renderTemplates();
      app.populateMap(this.visibleProperties);
    });
    // this.$filterShortTerm.change(function() {
    //   app.filterParams.shortTerm = this.checked;
    //   app.renderTemplates();
    //   app.populateMap(this.visibleProperties);
    // });
  }

  setSortParams() {
    const app = this;
    this.$sortButtons.click(function(){
      const $clickedButton = $(this)
      app.sortParams = app.sortingService.setSortParams(app, $clickedButton);
      app.styleSortButtons($clickedButton);
      app.renderTemplates();
    });
  }

  styleSortButtons(clickedButton) {
    this.$sortButtons.removeClass('is-active is-ascending is-descending');
    clickedButton.addClass('is-active');
    const thisSortParam = clickedButton.attr('data-sort');
    const ascending = this.sortParams[thisSortParam].sortDown;
    const className = ascending ? 'is-ascending' : 'is-descending';
    clickedButton.addClass('is-active '+ className);
  }

  setRetailSquareFootageRange() {
    const squareFootages = this.allProperties.map(function(property){
      return property.property_available_spaces;
    }).reduce(function(accumulator, currentValue) {
      return accumulator.concat(currentValue);
    }, []);
    const min = Math.min.apply(Math, squareFootages.filter(function(availableSpace){
      return availableSpace > 0;
    }));
    const max = Math.max.apply(Math, squareFootages);
    this.squareFootageRange = [min, max];
  }

  clearFilterSelects(thisInput) {
    const app = this;
    this.$filterSelects.not(thisInput).val('');
    const thisFilter = thisInput.getAttribute('data-filter');
    // const filterSelects = ['state', 'region', 'msa', 'spaceType'];
    const filterSelects = ['state', 'region', 'msa'];
    const index = filterSelects.indexOf(thisFilter);
    filterSelects.splice(index, 1);
    filterSelects.forEach(function(filterString) {
      delete app.filterParams[filterString];
    })
  }

  clearAllFilters(thisInput) {
    this.resetInputs(thisInput);
    this.initFilterParams();
  }

  resetInputs(thisInput) {
    const app = this;
    const exclude = thisInput ? thisInput : '';
    this.$filterSelects.not(exclude).val('');
    if (!exclude) {
      this.filterRangeSlider.set([0, app.squareFootageRange[1]]);
      // this.$filterSpaceType.filter('[value="retail"]').prop('checked', 'checked');
      // this.$filterShortTerm.prop('checked', false);
    }
  }

  createSlider() {
    const slider = document.getElementById('range-slider');
    let rangeObject;
    if(this.squareFootageRange[1] > this.maximumSquareFootageForGraph) {
      rangeObject = {
    		'min': 0,
        '95%': this.maximumSquareFootageForGraph,
    		'max': this.squareFootageRange[1]
    	}
    }
    else {
      rangeObject = {
    		'min': 0,
    		'max': this.squareFootageRange[1]
    	}
    }

    noUiSlider.create(slider, {
    	start: [0, this.squareFootageRange[1]],
    	connect: true,
    	range: rangeObject
    });
    this.filterRangeSlider = slider.noUiSlider;
  }

  createSliderGraph() {
    const graphArray = this.batchFootages(20)
    const maxOfGraphArray = Math.max.apply(Math, graphArray);
    const percentageBarWidth = 100/graphArray.length;

    const $graph = $('<div></div>').attr({'class': 'filter__range-graph'});

    for (var i = 0; i < graphArray.length; i++) {
      // BUG: not quite wide enough
      const width = i < graphArray.length - 1 ? percentageBarWidth : percentageBarWidth + 1;
      const inversePercentageHeight = 100 * (1 - graphArray[i]/maxOfGraphArray);
      const $bar = $('<div/>', { class: 'filter__range-graph__bar--inverse', style: 'height: '+inversePercentageHeight+'%; width: '+width+'%;' }).appendTo($graph);
    }
    $('.noUi-base').prepend($graph);
  }

  batchFootages(numBatchesParam) {
    let numBatches = numBatchesParam;
    // NOTE: if numBatches changes from 20, the rangeObject in the noUiSlider creation may need to change
    const app = this;
    let arrayOfFootageRanges = Array(numBatches);
    for (let i = 0; i < arrayOfFootageRanges.length; i += 1) {
      arrayOfFootageRanges[i] = [];
    }

    const maximum = this.squareFootageRange[1] > this.maximumSquareFootageForGraph ? this.maximumSquareFootageForGraph : this.squareFootageRange[1];
    if (this.squareFootageRange[1] > this.maximumSquareFootageForGraph){
      numBatches -= 1;
    }

    const binSize = maximum/numBatches;

    let greaterThan25K = [];

    this.allProperties.map(function(property){
      return property.property_available_spaces;
    })
    // flatten
    .reduce(function(accumulator, availableSpace) {
      return accumulator.concat(availableSpace);
    }, [])
    .filter(function(availableSpace){
      if (availableSpace >= app.maximumSquareFootageForGraph) {
        greaterThan25K.push(availableSpace);
      }
      return availableSpace > 0 && availableSpace < app.maximumSquareFootageForGraph;
    })
    .forEach(function(footage){
      for (var i = 0; i < numBatches; i++) {
        const bottomLimit = i * binSize;
        const topLimit = (i+1) * binSize;
        if(footage > bottomLimit && footage <= topLimit){
          arrayOfFootageRanges[i].push(footage);
          break;
        }
      }
    });
    if (this.squareFootageRange[1] > this.maximumSquareFootageForGraph){
      arrayOfFootageRanges[arrayOfFootageRanges.length - 1] = greaterThan25K;
    }

    // const zeroFootages = this.allProperties.filter(function(property){
    //   return property.property_available_space === 0;
    // });
    //
    // arrayOfFootageRanges.unshift(zeroFootages);

    return arrayOfFootageRanges.map(function(array){
      return array.length;
    });
  }

  filterProperties() {
    const filterKeys = Object.keys(this.filterParams);
    const props = this.allProperties.filter(function(property){
      if (this.filterParams['state']) {
        return this.filterParams['state'] == property['state'];
      }
      else if (this.filterParams['region']) {
        return this.filterParams['region'] == property['region'];
      }
      else if (this.filterParams['msa']) {
        return this.filterParams['msa'] == property['msa'];
      }
      return true;
    // }.bind(this)).filter(function(property){
    //   return property.property_characteristics.includes(this.filterParams['spaceType']);
    }.bind(this)).filter(function(property){
      const availableSpaces = property.property_available_spaces;
      const range = this.filterParams['footageRange']
      const hasSomeInRange = availableSpaces.some(function(space){
        return parseInt(space) >= range[0] && parseInt(space) <= range[1];
      });
      return hasSomeInRange;
    }.bind(this))
    .filter(function(property){
      // if (this.filterParams['shortTerm']) {
      //   return property['short_term_available'];
      // }
      return true;
    }.bind(this));
    this.visibleProperties = props;
  }
}



// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/properties-app/PropertiesApp.jsx